/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { variantOptionsStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsVariantOptions";
import { screen } from "@eisinc/XDL/Helpers";
import Share from "@eisinc/XDL/Icons/Share";
import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { customerPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { manufacturingPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";

pageTitleStyles.brandGridItem = {
    css: css`
        display: none !important;
    `,
};

pageTitleStyles.titleText = {
    variant: "h2",
    size: 26,
    lineHeight: "32px",
    weight: "normal",
    css: css`
        letter-spacing: 0;
        margin: 10px 0 50px 0;

        ${screen("lte", "lg")`
            margin: 10px 0 25px 0;
        `}

        ${screen("lte", "md")`
            font-size: 26px;
            line-height: 32px;
        `}

        ${screen("lte", "sm")`
            font-size: 14px;
            line-height: 20px;
            margin: 0 0 10px 0;
        `}
    `,
};

manufacturingPartNumberStyles.labelText = customerPartNumberStyles.labelText = {
    size: 14,
    weight: "bold",
    lineHeight: "22px",
    css: css`
        margin-right: 2px;

        &:after {
            display: inline-block;
            content: ":";
        }
    `,
};

manufacturingPartNumberStyles.valueText = customerPartNumberStyles.valueText = {
    size: 14,
    lineHeight: "22px",
};

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        margin-top: 0;
    `,
};

shareLinkStyles.link = {
    link: {
        icon: {
            iconProps: {
                src: Share,
                size: 18,
                color: "primary.main",
            },
        },
        color: "text.main",
        typographyProps: {
            size: 14,
            lineHeight: "20px",
        },
    },
};

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            max-width: 100%;
        }
    `,
};

variantOptionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    `,
};

variantOptionsStyles.select = {
    cssOverrides: {
        formField: css`
            flex: 1 1 50%;
            padding: 0 15px;
            margin-bottom: 15px;

            ${screen("lte", "sm")`
                flex: 1 1 100%;
            `}
        `,
    },
};

availabilityStyles.availability = {
    container: {
        css: css`
            ${screen("lte", "sm")`
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 5px;
                margin-bottom: 5px;
            `}
        `,
    },
};
